module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Book":"Livre","Computer":"Informatique","Art":"Arts","OfficeSupply":"Papeterie"},"fr":{"Book":"Livre","Computer":"Informatique","Art":"Arts","OfficeSupply":"Papeterie"}}')
  delete Component.options._Ctor
}
